import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const defaultSilkImg = '/pdfs/missing-silk-40x29.133.0.png';

class Image extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { src: props.src };
    }

    onError = () => {
        this.setState({ src: `${this.props.imgHost}${defaultSilkImg}` });
    }

    render() {
        return (
            <img
                className={this.props.imgClass}
                src={this.state.src}
                alt={this.props.alt}
                onError={this.onError}
            />
        );
    }
}


Image.propTypes = {
    src: PropTypes.string.isRequired,
    imgHost: PropTypes.string.isRequired,
    imgClass: PropTypes.string,
    alt: PropTypes.string.isRequired,
};

export default Image;



// WEBPACK FOOTER //
// ./src/js/shared/Image.jsx